const STEPS = [
  { key: "Open", label: "Open" },
  { key: "In Progress", label: "In Progress" },
  { key: "Complete", label: "Complete" },
  { key: "Close", label: "Closed" },
];

const STAGE_STEP = {
  Open: 1, Reopen: 1, Reopened: 1,
  "In Progress": 2, Active: 2,
  Complete: 3, Resolved: 3,
  Close: 4, Closed: 4,
};

const BRAND = "#6D17CE";
const GRAY = "#9ca3af";

const icons = [
  (c) => (
    <svg width="10" height="10" viewBox="0 0 24 24" fill={c}>
      <circle cx="12" cy="12" r="8" />
    </svg>
  ),
  (c) => (
    <svg width="10" height="10" viewBox="0 0 24 24" fill="none" stroke={c} strokeWidth="2.5">
      <circle cx="12" cy="12" r="9" />
      <path d="M12 6v6l4 2" />
    </svg>
  ),
  (c) => (
    <svg width="10" height="10" viewBox="0 0 24 24" fill="none" stroke={c} strokeWidth="3" strokeLinecap="round" strokeLinejoin="round">
      <polyline points="4 12 9 17 20 6" />
    </svg>
  ),
  (c) => (
    <svg width="10" height="10" viewBox="0 0 24 24" fill={c}>
      <path d="M18 8h-1V6c0-2.76-2.24-5-5-5S7 3.24 7 6v2H6c-1.1 0-2 .9-2 2v10c0 1.1.9 2 2 2h12c1.1 0 2-.9 2-2V10c0-1.1-.9-2-2-2zm-6 9c-1.1 0-2-.9-2-2s.9-2 2-2 2 .9 2 2-.9 2-2 2zm3-9H9V6c0-1.66 1.34-3 3-3s3 1.34 3 3v2z" />
    </svg>
  ),
];

export const TicketStageStepper = ({ stage }) => {
  if (stage === "Reject" || stage === "Rejected") {
    return (
      <div className="flex items-center justify-center">
        <div className="w-6 h-6 rounded-full bg-red-100 flex items-center justify-center" title="Rejected">
          <svg width="10" height="10" viewBox="0 0 24 24" fill="none" stroke="#dc2626" strokeWidth="3" strokeLinecap="round">
            <line x1="6" y1="6" x2="18" y2="18" />
            <line x1="18" y1="6" x2="6" y2="18" />
          </svg>
        </div>
      </div>
    );
  }

  if (stage === "Draft") {
    return (
      <div className="flex items-center justify-center">
        <div className="w-6 h-6 rounded-full bg-amber-100 flex items-center justify-center" title="Draft">
          <svg width="10" height="10" viewBox="0 0 24 24" fill="#d97706">
            <path d="M14 2H6a2 2 0 00-2 2v16a2 2 0 002 2h12a2 2 0 002-2V8l-6-6zM13 9V3.5L18.5 9H13z" />
          </svg>
        </div>
      </div>
    );
  }

  const current = STAGE_STEP[stage] || 0;

  return (
    <div className="flex items-center justify-center gap-0.5">
      {STEPS.map((step, i) => {
        const num = i + 1;
        const active = num <= current;
        const isCur = num === current;
        return (
          <div key={step.key} className="flex items-center gap-0.5">
            {i > 0 && (
              <div className={`h-0.5 w-5 rounded-full ${num <= current ? "bg-jiojbm25" : "bg-gray-200"}`} />
            )}
            <div className="relative group">
              <div
                className={`w-6 h-6 rounded-full flex items-center justify-center transition-all ${
                  active ? "bg-jiojbm20" : "bg-gray-100"
                } ${isCur ? "ring-2 ring-jiojbmpurple ring-offset-1" : ""}`}
              >
                {icons[i](active ? BRAND : GRAY)}
              </div>
              <div className="absolute bottom-full left-1/2 -translate-x-1/2 mb-1.5 hidden group-hover:block text-[9px] font-bold text-white bg-gray-800 rounded px-1.5 py-0.5 whitespace-nowrap z-10">
                {step.label}
              </div>
            </div>
          </div>
        );
      })}
    </div>
  );
};
